import React, { useState, useRef } from "react";

const questions = [
  {
    title: (
      <>
        <span className="font-bold">Review materials contracts </span>
        including
supply agreements, guarantees, indemnities, letters of comfort provided to
third parties
      </>
    ),
    uploads: [
      "Attach copy of document here (pdf , .Jpeg)",
      "Attach copy of document here (pdf , .Jpeg)",
    ],
  },
];

const OptionButton = ({ label, selected, onClick }) => (
  <div className="flex flex-col items-center space-y-2 md:space-y-5">
    <span className="text-[8px] md:text-[24px] font-medium">{label}</span>
    <button
      onClick={onClick}
      className={`w-[20px] h-[20px] md:w-[53px] md:h-[53px] rounded-full transition
        ${selected ? 'bg-[#03897B] border-[3px] md:border-[8px] border-white' : 'bg-transparent border-[6px] md:border-[8px] border-white'}
      `}
    ></button>
  </div>
);

const UploadBox = ({ text, image, onImageChange }) => {
  const inputRef = useRef();

  const handleClick = () => {
    inputRef.current.click();
  };

  return (
    <div
      className="w-[40px] md:w-[182px] h-full mx-1 md:mx-12 bg-[#E7EBEB] rounded-[5px] p-2 md:p-4 text-[6px] md:text-[18px] leading-snug relative flex items-center justify-center overflow-hidden"
    >
      <input
        type="file"
        accept="image/*"
        ref={inputRef}
        onChange={onImageChange}
        style={{ display: "none" }}
      />
      <div
        onClick={handleClick}
        className="absolute top-1 right-2 text-[5px] md:text-[24px] cursor-pointer z-10"
      >
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746028067/Add_square_ztbsgd.png"
          alt="Add"
          className="w-[10px] md:w-[34px]"
        />
      </div>
      {image ? (
        <img
          src={URL.createObjectURL(image)}
          alt="Uploaded"
          className="w-full h-full object-cover rounded-[5px]"
        />
      ) : (
        <p className="absolute bottom-10 md:bottom-12 p-4">{text}</p>
      )}
    </div>
  );
};

export default function AGREEMENT() {
  const [responses, setResponses] = useState({});
  const [uploads, setUploads] = useState({});

  const handleSelect = (index, value) => {
    setResponses({ ...responses, [index]: value });
  };

  const handleUploadChange = (questionIndex, uploadIndex, file) => {
    setUploads((prev) => ({
      ...prev,
      [questionIndex]: {
        ...(prev[questionIndex] || {}),
        [uploadIndex]: file,
      },
    }));
  };

  return (
    <div className="space-y-4 ">
     
    <div>
      <div className="flex justify-end md:mt-2 mt-2">
        <button
          className="flex items-center md:gap-2 gap-2  hover:bg-[#0f1f1a] text-black hover:text-white  md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition"
        >
          Save
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
            alt="Save Icon"
            className="md:w-11 md:h-11 h-3 w-3"
          />
        </button>
      </div>
        <h2 className="text-[8px] md:text-[24px] font-bold  text-[#03897B] ">
          <span className="text-[#979797]">Section 4 : </span> AGREEMENTS
        </h2>
  
      </div>

      {questions.map((q, i) => (
        <div
          key={i}
          className="flex space-x-2 h-[100px] md:h-[233px] md:min-w-[700px]"
        >
          {/* Left: Question */}
          <div className="w-[100px] md:w-[390px] bg-[#E7EBEB] rounded-[5px] p-3 md:p-4 text-[6px] md:text-[24px] inline leading-[1.2]">
            {q.title}
          </div>

          {/* Middle: Y / N / NA Buttons */}
          {["Y", "N", "NA"].map((opt) => (
            <div
              key={opt}
              className="w-[40px] md:w-[100px] bg-[#E7EBEB] rounded-[5px] flex justify-center items-center md:pb-16"
            >
              <OptionButton
                label={opt}
                selected={responses[i] === opt}
                onClick={() => handleSelect(i, opt)}
              />
            </div>
          ))}

          {/* Right: Upload Boxes */}
          <div className="flex space-x-1 md:-space-x-5">
            {q.uploads?.map((text, idx) => (
              <UploadBox
                key={idx}
                text={text}
                image={uploads[i]?.[idx]}
                onImageChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleUploadChange(i, idx, file);
                  }
                }}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
